import { createFileRoute } from '@tanstack/react-router'
import { observer } from 'mobx-react-lite'
import PostsList from '@/components/post/postsList.jsx'
import { useEffect } from 'react'
import useView from '@/hooks/useView.js'
import { LoadingIndicator, LoadingIndicatorTitle } from '@/components/ui/loadingIndicator.jsx'
import ContentMenu from '@/components/contentMenu/contentMenu.jsx'

const Index = () => {
  const { feedView } = useView()

  useEffect(() => {
    feedView.init().then()

    return () => {
      feedView.reset()
    }
  }, [feedView])

  if (!feedView.isInitialized)
    return (
      <LoadingIndicator>
        <LoadingIndicatorTitle>Loading...</LoadingIndicatorTitle>
      </LoadingIndicator>
    )

  return (
    <div className="animate-in fade-in w-full duration-1000">
      <div className="mx-auto w-full max-w-3xl">
        <ContentMenu />
      </div>

      <PostsList className="animate-in slide-in-from-bottom-3 my-6 duration-1000" />
    </div>
  )
}

export const Route = createFileRoute('/')({
  component: observer(Index),
})
